export const ROUTE_CONFIGURACION_USUARIOS_COMPRAS = 'administracion-pg:configuracion:usuarios-compras'
export const ROUTE_PERMISOS_ESTRUCTURA_ORGANIZACIONAL =
    'administracion-pg:configuracion:permisos-estructura-organizacional'
